module.exports = __webpack_public_path__ + "da1dc27b62d39eb5676cb0a824828201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/16.jpg
// module id = 1342
// module chunks = 47